import { render, staticRenderFns } from "./a-generic-text.vue?vue&type=template&id=c1afb646"
import script from "./a-generic-text.vue?vue&type=script&lang=js"
export * from "./a-generic-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports